import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { TakenLoginIdModule } from '../../../../shared/taken-login-id/taken-login-id.module';
import { IbanPipe } from '../../../pipes/iban.pipe';
import { BankAccountDialogModule } from '../bank-account-dialog/bank-account-dialog.module';
import { ErrorDialogModule } from '../error-dialog/error-dialog.module';
import { BankAccountWidgetComponent } from './bank-account-widget.component';

const materialModules = [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    ErrorDialogModule,
];

@NgModule({
    declarations: [BankAccountWidgetComponent, IbanPipe],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BankAccountDialogModule,
        TranslateModule.forChild(),
        TakenLoginIdModule,
        ...materialModules,
    ],
    providers: [],
    exports: [BankAccountWidgetComponent],
})
export class BankAccountWidgetModule {}
